(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Utilities
  --------------------------------------------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || (window.themeSettings && window.themeSettings.moneyFormat) || '${{amount}}';
    return fmt.replace('{{amount}}', value).replace('{{ amount }}', value);
  }

  /* ---------------------------------------------------------------------
     Theme (light/dark) toggle
  --------------------------------------------------------------------- */
  function initThemeToggle() {
    qsa('[data-theme-toggle]').forEach(function (btn) {
      if (btn.dataset.themeModeBound === '1') return;
      btn.dataset.themeModeBound = '1';
      btn.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-theme') || 'dark';
        var next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try { localStorage.setItem('outcost-theme-mode', next); } catch (e) {}
        btn.setAttribute('aria-label', next === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
        btn.setAttribute('aria-pressed', next === 'light' ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------------
     Header: nav drawer, cart drawer, mobile search overlay
  --------------------------------------------------------------------- */
  function initHeader() {
    var navDrawer = qs('[data-nav-drawer]');
    var menuToggle = qs('[data-menu-toggle]');
    if (navDrawer && menuToggle) {
      menuToggle.addEventListener('click', function () {
        navDrawer.setAttribute('data-open', 'true');
        navDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
      qsa('[data-menu-close]', navDrawer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          navDrawer.setAttribute('data-open', 'false');
          navDrawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });
    }

    var cartDrawer = qs('#cart-drawer');
    var cartToggle = qs('[data-cart-toggle]');
    if (cartDrawer && cartToggle) {
      cartToggle.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
      qsa('[data-cart-close]', cartDrawer).forEach(function (btn) {
        btn.addEventListener('click', closeCartDrawer);
      });
    }

    // Mobile full-screen search overlay
    var overlay = qs('[data-mobile-search-overlay]');
    var openBtn = qs('[data-mobile-search-open]');
    if (overlay && openBtn) {
      var closeBtn = qs('[data-mobile-search-close]', overlay);
      var input = qs('[data-mobile-search-input]', overlay);

      openBtn.addEventListener('click', function () {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (input) setTimeout(function () { input.focus(); }, 50);
      });

      function closeOverlay() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
      });
    }
  }

  /* ---------------------------------------------------------------------
     Cart drawer (AJAX)
  --------------------------------------------------------------------- */
  function openCartDrawer() {
    var cartDrawer = qs('#cart-drawer');
    if (!cartDrawer) return;
    renderCartDrawer();
    cartDrawer.setAttribute('data-open', 'true');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var cartDrawer = qs('#cart-drawer');
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', 'false');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        var body = qs('#CartDrawerBody');
        var footer = qs('#CartDrawerFooter');
        if (!body || !footer) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<p style="color:var(--color-text-muted);font-size:13px;">Your cart is empty</p>';
          footer.innerHTML = '';
          return;
        }

        body.innerHTML = cart.items.map(function (item) {
          return '' +
            '<div class="cart-line" data-cart-line="' + item.key + '">' +
              '<img src="' + (item.image || '') + '" alt="" width="64" height="64" loading="lazy">' +
              '<div>' +
                '<div class="cart-line__title">' + item.product_title + '</div>' +
                '<div class="cart-line__meta">' + (item.variant_title || '') + ' &middot; ' + formatMoney(item.final_price) + '</div>' +
                '<div class="cart-line__qty">' +
                  '<button type="button" data-cart-qty-decrease>&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-cart-qty-increase>+</button>' +
                '</div>' +
              '</div>' +
            '</div>';
        }).join('');

        footer.innerHTML = '' +
          '<div class="cart-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
          '<a href="/checkout" class="btn btn--pill btn--primary" style="width:100%;">Checkout</a>';

        qsa('[data-cart-qty-increase]', body).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = btn.closest('[data-cart-line]').getAttribute('data-cart-line');
            changeCartLine(key, btn.parentElement.querySelector('span').textContent, 1);
          });
        });
        qsa('[data-cart-qty-decrease]', body).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = btn.closest('[data-cart-line]').getAttribute('data-cart-line');
            changeCartLine(key, btn.parentElement.querySelector('span').textContent, -1);
          });
        });
      })
      .catch(function () { /* silent fail */ });
  }

  function changeCartLine(key, currentQty, delta) {
    var newQty = Math.max(0, parseInt(currentQty, 10) + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function () { renderCartDrawer(); })
      .catch(function () {});
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }

  function addToCartAjax(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }

  /* ---------------------------------------------------------------------
     Quick add (on product cards)
  --------------------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.classList.add('is-loading');
      addToCartAjax(variantId)
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (res.ok) openCartDrawer();
        })
        .catch(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------------------------------------------------------------------
     Carousels (horizontal product carousels)
  --------------------------------------------------------------------- */
  function initCarousels() {
    qsa('[data-carousel]').forEach(function (carousel) {
      var track = qs('[data-carousel-track]', carousel);
      var prev = qs('[data-carousel-prev]', carousel);
      var next = qs('[data-carousel-next]', carousel);
      var dotsWrap = carousel.parentElement.querySelector('[data-carousel-dots]');
      if (!track) return;

      function slideWidth() {
        var slide = track.children[0];
        return slide ? slide.getBoundingClientRect().width + 16 : 300;
      }

      var maxScroll = 0;
      function updateArrows() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 4;
      }
      function measureCarousel() {
        maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        updateArrows();
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideWidth() * 2, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: slideWidth() * 2, behavior: 'smooth' });
      });
      var scrollRaf = 0;
      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          updateArrows();
        });
      }, { passive: true });
      measureCarousel();
      window.addEventListener('resize', measureCarousel, { passive: true });

      if (dotsWrap && track.children.length > 0) {
        var dotCount = Math.max(1, Math.ceil(track.children.length / 5));
        for (var i = 0; i < dotCount; i++) {
          var dot = document.createElement('span');
          if (i === 0) dot.classList.add('is-active');
          dotsWrap.appendChild(dot);
        }
        track.addEventListener('scroll', function () {
          var progress = track.scrollLeft / (track.scrollWidth - track.clientWidth || 1);
          var activeIndex = Math.round(progress * (dotCount - 1));
          qsa('span', dotsWrap).forEach(function (d, idx) {
            d.classList.toggle('is-active', idx === activeIndex);
          });
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     Hero carousel: autoplay, swipe, arrows, dots, pause on hover/focus,
     keyboard navigation
  --------------------------------------------------------------------- */
  function initHeroCarousel() {
    qsa('[data-hero-carousel]').forEach(function (root) {
      var slides = qsa('[data-hero-slide]', root);
      if (slides.length <= 1) return;

      var dotsWrap = qs('[data-hero-dots]', root);
      var prevBtn = qs('[data-hero-prev]', root);
      var nextBtn = qs('[data-hero-next]', root);
      var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || 0;
      var current = 0;
      var timer = null;

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'hero-carousel__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { goTo(i); restart(); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      function show(index) {
        slides.forEach(function (s, i) { s.hidden = i !== index; });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        current = index;
      }
      function goTo(index) { show((index + slides.length) % slides.length); }
      function nextSlide() { goTo(current + 1); }
      function prevSlide() { goTo(current - 1); }

      function start() {
        if (!interval) return;
        stop();
        timer = setInterval(nextSlide, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      if (nextBtn) nextBtn.addEventListener('click', function () { nextSlide(); restart(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prevSlide(); restart(); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { nextSlide(); restart(); }
        if (e.key === 'ArrowLeft') { prevSlide(); restart(); }
      });

      // touch swipe
      var startX = 0;
      root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
      root.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 40) { diff < 0 ? nextSlide() : prevSlide(); }
        start();
      }, { passive: true });

      show(0);
      start();
    });
  }

  /* ---------------------------------------------------------------------
     FAQ accordion
  --------------------------------------------------------------------- */
  function initFaq() {
    qsa('[data-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.faq-accordion__item');
        var panel = qs('[data-faq-panel]', item);
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---------------------------------------------------------------------
     Product gallery
  --------------------------------------------------------------------- */
  function initProductGallery() {
    var gallery = qs('[data-product-gallery]');
    if (!gallery) return;

    var slides = qsa('[data-gallery-slide]', gallery);
    var thumbs = qsa('[data-gallery-thumb]', gallery);

    function showSlide(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showSlide(i); });
    });

    var prevBtn = qs('[data-gallery-prev]', gallery);
    var nextBtn = qs('[data-gallery-next]', gallery);
    function currentIndex() {
      return slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      var i = currentIndex();
      showSlide(i <= 0 ? slides.length - 1 : i - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var i = currentIndex();
      showSlide(i >= slides.length - 1 ? 0 : i + 1);
    });

    // touch swipe
    var main = qs('[data-gallery-main]', gallery);
    if (main) {
      var startX = 0;
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 40) {
          var i = currentIndex();
          if (diff < 0) showSlide(i >= slides.length - 1 ? 0 : i + 1);
          else showSlide(i <= 0 ? slides.length - 1 : i - 1);
        }
      }, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
    });

    // zoom / lightbox
    var zoomBtn = qs('[data-gallery-zoom]', gallery);
    var lightbox = qs('[data-gallery-lightbox]');
    var lightboxContent = qs('[data-gallery-lightbox-content]');
    if (zoomBtn && lightbox && lightboxContent) {
      zoomBtn.addEventListener('click', function () {
        var activeSlide = slides[currentIndex()];
        var img = activeSlide ? activeSlide.querySelector('img') : null;
        if (img) lightboxContent.innerHTML = '<img src="' + img.src + '" alt="' + (img.alt || '') + '">';
        lightbox.setAttribute('data-open', 'true');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
      qsa('[data-gallery-lightbox-close]', lightbox).forEach(function (btn) {
        btn.addEventListener('click', function () {
          lightbox.setAttribute('data-open', 'false');
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });
    }
  }

  /* ---------------------------------------------------------------------
     Product form: variant selection + AJAX add to cart / buy now
  --------------------------------------------------------------------- */
  function initProductForm() {
    var form = qs('[data-product-form]');
    if (!form) return;

    var jsonEl = qs('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }

    var hiddenIdInput = qs('[data-selected-variant-id]', form);
    var priceEl = qs('[data-product-price]');
    var addBtn = qs('[data-add-to-cart-btn]', form);
    var buyBtn = qs('[data-buy-now-btn]', form);
    var errorEl = qs('[data-form-error]', form);

    var optionGroups = qsa('.product-form__option', form);
    var selections = optionGroups.map(function (group) {
      var selected = qs('.option-btn.is-selected', group);
      return selected ? selected.getAttribute('data-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selections.every(function (sel, i) { return sel === null || opts[i] === sel; });
      });
    }

    function refreshAvailability() {
      var matched = findVariant();
      optionGroups.forEach(function (group, gi) {
        qsa('.option-btn', group).forEach(function (btn) {
          var testSelections = selections.slice();
          testSelections[gi] = btn.getAttribute('data-value');
          var possible = variants.some(function (v) {
            var opts = [v.option1, v.option2, v.option3];
            return testSelections.every(function (sel, i) { return sel === null || opts[i] === sel; }) && v.available;
          });
          btn.classList.toggle('is-unavailable', !possible);
        });
      });

      if (matched) {
        hiddenIdInput.value = matched.id;
        if (priceEl) {
          priceEl.innerHTML = matched.compare_at_price && matched.compare_at_price > matched.price
            ? '<span class="product-section__price-sale">' + formatMoney(matched.price) + '</span><span class="product-section__price-compare">' + formatMoney(matched.compare_at_price) + '</span>'
            : '<span>' + formatMoney(matched.price) + '</span>';
        }
        var available = matched.available;
        [addBtn, buyBtn].forEach(function (btn) { if (btn) btn.disabled = !available; });
        if (addBtn) addBtn.querySelector('.btn__text').textContent = available ? 'Add to Cart' : 'Sold Out';
      } else {
        [addBtn, buyBtn].forEach(function (btn) { if (btn) btn.disabled = true; });
      }
    }

    qsa('[data-option-value]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var groupIndex = parseInt(btn.getAttribute('data-option-index'), 10);
        var group = optionGroups[groupIndex];
        qsa('.option-btn', group).forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selections[groupIndex] = btn.getAttribute('data-value');
        refreshAvailability();
      });
    });

    refreshAvailability();

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        errorEl.hidden = true;
        addBtn.classList.add('is-loading');
        addToCartAjax(hiddenIdInput.value)
          .then(function (res) {
            addBtn.classList.remove('is-loading');
            if (!res.ok) {
              errorEl.textContent = res.data.description || 'Could not add item to cart.';
              errorEl.hidden = false;
              return;
            }
            openCartDrawer();
          })
          .catch(function () {
            addBtn.classList.remove('is-loading');
            errorEl.textContent = 'Something went wrong. Please try again.';
            errorEl.hidden = false;
          });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (buyBtn.disabled) return;
        buyBtn.classList.add('is-loading');
        addToCartAjax(hiddenIdInput.value)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyBtn.classList.remove('is-loading'); });
      });
    }
  }

  /* ---------------------------------------------------------------------
     Size chart modal
  --------------------------------------------------------------------- */
  function initSizeChart() {
    var modal = qs('[data-size-chart-modal]');
    var openBtn = qs('[data-size-chart-open]');
    if (!modal || !openBtn) return;
    openBtn.addEventListener('click', function () {
      modal.setAttribute('data-open', 'true');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
    function close() {
      modal.setAttribute('data-open', 'false');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    qsa('[data-size-chart-close]', modal).forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') close();
    });
  }

  /* ---------------------------------------------------------------------
     Product recommendations (async load)
  --------------------------------------------------------------------- */
  function initRecommendations() {
    var section = qs('[data-product-recommendations]');
    if (!section) return;
    var url = section.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newSection = temp.querySelector('[data-product-recommendations]');
        if (newSection && newSection.innerHTML.trim() !== '') {
          section.innerHTML = newSection.innerHTML;
          initCarousels();
        }
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------------
     Predictive search: renders real product cards (image, title, price,
     compare-at, availability) instead of plain text links. Works
     identically for the desktop header dropdown and the mobile
     full-screen overlay.
  --------------------------------------------------------------------- */
  function buildProductCardHtml(p) {
    var img = p.featured_image ? p.featured_image.url : (p.image || '');
    var price = formatMoney(p.price);
    var compareHtml = (p.compare_at_price_max && p.compare_at_price_max > p.price)
      ? ' <s>' + formatMoney(p.compare_at_price_max) + '</s>' : '';
    var soldOut = p.available === false;
    return '' +
      '<a class="predictive-search__item predictive-search__item--grid" href="' + p.url + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<span class="predictive-search__item-info">' +
          '<span class="predictive-search__item-title">' + p.title + '</span>' +
          '<span class="predictive-search__item-price">' + price + compareHtml + '</span>' +
          (soldOut ? '<span class="predictive-search__item-price" style="color:var(--color-text-muted)">Sold out</span>' : '') +
        '</span>' +
      '</a>';
  }

  function initPredictiveSearch() {
    var containers = qsa('[data-predictive-search]');
    if (!containers.length) return;

    var baseUrl = (window.themeSettings && window.themeSettings.predictiveSearchUrl) || '/search/suggest';
    var searchUrl = (window.themeSettings && window.themeSettings.searchUrl) || '/search';

    containers.forEach(function (container) {
      var input = qs('[data-predictive-search-input]', container);
      var results = qs('[data-predictive-search-results]', container);
      if (!input || !results) return;

      var debounceTimer = null;
      var currentController = null;

      function hideResults() {
        results.hidden = true;
        results.innerHTML = '';
      }

      function renderProducts(products, term) {
        if (!products.length) {
          results.innerHTML = '<div class="predictive-search__empty">No products found for &ldquo;' + term + '&rdquo;</div>';
          results.hidden = false;
          return;
        }

        var html = '<div class="predictive-search__grid">' + products.map(buildProductCardHtml).join('') + '</div>';
        html += '<a class="predictive-search__view-all" href="' + searchUrl + '?q=' + encodeURIComponent(term) + '&type=product">View all results for &ldquo;' + term + '&rdquo;</a>';
        results.innerHTML = html;
        results.hidden = false;
      }

      function search(term) {
        if (currentController) currentController.abort();
        var controller = ('AbortController' in window) ? new AbortController() : null;
        currentController = controller;

        results.innerHTML = '<div class="predictive-search__loading">Searching&hellip;</div>';
        results.hidden = false;

        var url = baseUrl + '?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=8' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title';

        fetch(url, { signal: controller ? controller.signal : undefined })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderProducts(products, term);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            hideResults();
          });
      }

      function handleInput() {
        var term = input.value.trim();
        clearTimeout(debounceTimer);
        if (term.length < 2) { hideResults(); return; }
        debounceTimer = setTimeout(function () { search(term); }, 250);
      }

      input.addEventListener('input', handleInput);

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var term = input.value.trim();
          if (term.length > 0) window.location.href = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
        }
        if (e.key === 'Escape') { hideResults(); input.blur(); }
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.innerHTML.trim() !== '') results.hidden = false;
      });

      document.addEventListener('click', function (e) {
        if (!container.contains(e.target)) hideResults();
      });
    });
  }

  /* ---------------------------------------------------------------------
     Contact form: conditional file-upload field for return/exchange
     issues + client-side validation. Shopify's native contact form
     cannot process file attachments, so if a file is chosen we tell the
     person to attach it via the email reply instead of pretending it
     uploaded.
  --------------------------------------------------------------------- */
  function initContactForm() {
    var form = qs('[data-contact-form]');
    if (!form) return;

    var issueSelect = qs('[data-issue-select]', form);
    var conditional = qs('[data-image-upload-field]', form);
    var fileInput = qs('[data-file-input]', conditional);
    var filePreview = qs('[data-file-preview]', conditional);
    var imageTriggers = (form.getAttribute('data-image-issue-values') || '').split(',');

    function refreshConditional() {
      if (!issueSelect || !conditional) return;
      var show = imageTriggers.indexOf(issueSelect.value) !== -1;
      conditional.classList.toggle('is-visible', show);
    }

    if (issueSelect) {
      issueSelect.addEventListener('change', refreshConditional);
      refreshConditional();
    }

    if (fileInput && filePreview) {
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) {
          filePreview.textContent = 'Selected: ' + fileInput.files[0].name + ' — please also attach this file when you reply to our confirmation email, as it will not be uploaded automatically.';
        } else {
          filePreview.textContent = '';
        }
      });
    }

    form.addEventListener('submit', function (e) {
      var requiredFields = qsa('[required]', form);
      var hasError = false;
      requiredFields.forEach(function (field) {
        var wrapper = field.closest('.form-field');
        if (!field.value.trim()) {
          hasError = true;
          if (wrapper) wrapper.classList.add('has-error');
        } else if (wrapper) {
          wrapper.classList.remove('has-error');
        }
      });
      if (hasError) e.preventDefault();
    });
  }

  /* ---------------------------------------------------------------------
     Order tracking: guest lookup by order number + email. Calls the
     merchant's own secure backend (never Shopify's Admin API directly —
     that never happens client-side). Renders a full order summary,
     line items, price breakdown, and shipment/tracking info from
     whatever the backend actually returns. Never fabricates data.
  --------------------------------------------------------------------- */
  function initOrderTracking() {
    var root = qs('[data-order-tracking]');
    if (!root) return;

    var endpoint = root.getAttribute('data-endpoint');
    var formState = qs('[data-tracking-form-state]', root);
    var resultState = qs('[data-tracking-result-state]', root);
    var form = qs('[data-order-tracking-form]', root);
    var submitBtn = qs('[data-tracking-submit]', form);
    var messageEl = qs('[data-tracking-message]', root);

    function escapeHtml(str) {
      if (str === null || str === undefined) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatMoney(moneyObj) {
      if (!moneyObj || moneyObj.amount === undefined || moneyObj.amount === null) return null;
      var value = parseFloat(moneyObj.amount).toFixed(2);
      var currency = moneyObj.currency || '';
      return currency + ' ' + value;
    }

    function showMessage(text) {
      if (!messageEl) return;
      if (!text) { messageEl.hidden = true; messageEl.textContent = ''; return; }
      messageEl.textContent = text;
      messageEl.hidden = false;
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.classList.toggle('is-loading', isLoading);
      submitBtn.querySelector('.btn__text').textContent = isLoading ? 'Checking your order…' : 'Track Order';
    }

    function renderLineItem(item) {
      var priceHtml;
      if (item.has_discount && item.original_price && item.final_price) {
        priceHtml =
          '<span class="order-line-item__price">' +
            '<s>' + escapeHtml(formatMoney(item.original_price)) + '</s> ' +
            '<strong>' + escapeHtml(formatMoney(item.final_price)) + '</strong>' +
          '</span>';
      } else {
        var single = item.final_price || item.original_price;
        priceHtml = '<span class="order-line-item__price"><strong>' + escapeHtml(formatMoney(single)) + '</strong></span>';
      }

      return '' +
        '<div class="order-line-item">' +
          '<div class="order-line-item__image-wrap">' +
            (item.image
              ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.image_alt || item.title) + '" loading="lazy">'
              : '') +
          '</div>' +
          '<div class="order-line-item__info">' +
            '<span class="order-line-item__title">' + escapeHtml(item.title) + '</span>' +
            (item.variant ? '<span class="order-line-item__variant">' + escapeHtml(item.variant) + '</span>' : '') +
            '<span class="order-line-item__qty">Qty: ' + escapeHtml(item.quantity) + '</span>' +
            priceHtml +
          '</div>' +
        '</div>';
    }

    function renderSummaryRow(label, moneyObj, isTotal) {
      var formatted = formatMoney(moneyObj);
      if (!formatted) return '';
      return '' +
        '<div class="order-summary__row' + (isTotal ? ' order-summary__row--total' : '') + '">' +
          '<span>' + label + '</span><span>' + escapeHtml(formatted) + '</span>' +
        '</div>';
    }

    function renderShipment(shipment, index, total) {
      var heading = total > 1 ? '<h3 class="order-shipment__heading">Shipment ' + (index + 1) + '</h3>' : '';
      var courierRow = shipment.company
        ? '<div class="order-shipment__row"><span>Courier</span><strong>' + escapeHtml(shipment.company) + '</strong></div>'
        : '';
      var statusRow = shipment.status
        ? '<div class="order-shipment__row"><span>Status</span><strong>' + escapeHtml(shipment.status) + '</strong></div>'
        : '';
      var trackingRow = shipment.number
        ? '' +
          '<div class="order-shipment__row">' +
            '<span>Tracking ID</span>' +
            '<strong class="order-shipment__tracking-id" data-tracking-id="' + escapeHtml(shipment.number) + '">' + escapeHtml(shipment.number) + '</strong>' +
          '</div>'
        : '';

      var buttons = '<div class="order-shipment__buttons">';
      if (shipment.number) {
        buttons += '<button type="button" class="btn btn--pill btn--secondary" data-copy-tracking="' + escapeHtml(shipment.number) + '">Copy Tracking ID</button>';
      }
      if (shipment.url) {
        buttons += '<a href="' + escapeHtml(shipment.url) + '" target="_blank" rel="noopener" class="btn btn--pill btn--primary">Track Shipment &rarr;</a>';
      } else if (shipment.number) {
        buttons += '<span class="order-shipment__no-link">Tracking link unavailable</span>';
      }
      buttons += '</div>';

      return '<div class="order-shipment">' + heading + courierRow + statusRow + trackingRow + buttons + '</div>';
    }

    function renderResult(data) {
      if (data && data.error) {
        var categoryLine = data.category
          ? '<p class="form-submit-note" style="margin-top:4px;">Category: <code>' + escapeHtml(data.category) + '</code></p>'
          : '';
        var statusLine = data.shopify_status
          ? '<p class="form-submit-note" style="margin-top:4px;">Shopify responded with status: <code>' + escapeHtml(data.shopify_status) + '</code></p>'
          : '';
        var messageLine = data.shopify_message
          ? '<p class="form-submit-note" style="margin-top:4px;">Message: <code>' + escapeHtml(data.shopify_message) + '</code></p>'
          : '';
        resultState.innerHTML =
          '<div class="form-card" style="text-align:center;">' +
            '<h2 class="order-not-found__title">Couldn\'t Check Your Order Right Now</h2>' +
            '<p class="form-page__text">Something went wrong on our end. Please try again shortly, or contact us if this keeps happening.</p>' +
            '<p class="form-submit-note" style="margin-top:14px;">Error code: <code>' + escapeHtml(data.error) + '</code></p>' +
            categoryLine +
            statusLine +
            messageLine +
          '</div>';
        resultState.hidden = false;
        formState.hidden = true;
        return;
      }

      if (!data || !data.found) {
        resultState.innerHTML =
          '<div class="form-card" style="text-align:center;">' +
            '<h2 class="order-not-found__title">Order Not Found</h2>' +
            '<p class="form-page__text">We couldn\'t find an order matching those details. Please check your order number and email address and try again.</p>' +
          '</div>';
        resultState.hidden = false;
        formState.hidden = true;
        return;
      }

      var order = data.order;
      var lineItemsHtml = (order.line_items || []).map(renderLineItem).join('');

      var summaryHtml = '' +
        renderSummaryRow('Subtotal', order.subtotal, false) +
        (order.discount && parseFloat(order.discount.amount) > 0 ? renderSummaryRow('Discount', order.discount, false) : '') +
        renderSummaryRow('Shipping', order.shipping, false) +
        renderSummaryRow('Total', order.total, true);

      var discountCodeHtml = (order.discount_codes && order.discount_codes.length)
        ? '<p class="order-summary__discount-code">Discount: ' + escapeHtml(order.discount_codes.join(', ')) + '</p>'
        : '';

      var shipmentsHtml;
      if (order.shipments && order.shipments.length > 0) {
        shipmentsHtml = order.shipments.map(function (s, i) { return renderShipment(s, i, order.shipments.length); }).join('');
      } else {
        shipmentsHtml =
          '<div class="form-card" style="text-align:center;">' +
            '<p class="form-page__text">Your order has been received, but shipment tracking information is not available yet.</p>' +
          '</div>';
      }

      resultState.innerHTML = '' +
        '<div class="order-summary-card">' +
          '<div class="order-summary-card__header">' +
            '<h2>Order ' + escapeHtml(order.name) + '</h2>' +
            (order.date ? '<p>Placed on ' + escapeHtml(order.date) + '</p>' : '') +
            (order.fulfillment_status ? '<span class="order-status-badge">Order Status: ' + escapeHtml(order.fulfillment_status) + '</span>' : '') +
          '</div>' +

          '<h3 class="order-summary-card__section-title">Products</h3>' +
          '<div class="order-line-items">' + lineItemsHtml + '</div>' +

          '<h3 class="order-summary-card__section-title">Order Summary</h3>' +
          '<div class="order-summary">' + summaryHtml + '</div>' +
          discountCodeHtml +

          '<h3 class="order-summary-card__section-title">Shipment</h3>' +
          '<div class="order-shipments">' + shipmentsHtml + '</div>' +
        '</div>' +
        '<button type="button" class="order-tracking__another btn btn--pill btn--outline" data-track-another">&larr; Track Another Order</button>';

      resultState.hidden = false;
      formState.hidden = true;

      qsa('[data-copy-tracking]', resultState).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.getAttribute('data-copy-tracking');
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(function () {
              var original = btn.textContent;
              btn.textContent = '✓ Copied';
              setTimeout(function () { btn.textContent = original; }, 1800);
            });
          }
        });
      });

      var againBtn = qs('[data-track-another]', resultState);
      if (againBtn) {
        againBtn.addEventListener('click', function () {
          resultState.hidden = true;
          resultState.innerHTML = '';
          formState.hidden = false;
          form.reset();
          showMessage('');
        });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showMessage('');

      var orderNumber = qs('[name="order_number"]', form).value.trim();
      var email = qs('[name="email"]', form).value.trim();

      if (!orderNumber || !email) {
        showMessage('Please fill in both fields.');
        return;
      }

      setLoading(true);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_number: orderNumber, email: email }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          setLoading(false);
          renderResult(data);
        })
        .catch(function () {
          setLoading(false);
          showMessage('Something went wrong checking your order. Please try again in a moment.');
        });
    });
  }

  /* ---------------------------------------------------------------------
     Palo Alto-inspired motion system
     Uses IntersectionObserver + transform/opacity for smooth, low-cost
     scroll reveals, staggered product cards, image hover zoom and buttons.
  --------------------------------------------------------------------- */
  function initPaloAnimations() {
    var enabled = document.documentElement.getAttribute('data-animations') !== 'false';
    if (!enabled || !('IntersectionObserver' in window)) {
      document.documentElement.classList.add('palo-motion-ready');
      return;
    }

    document.documentElement.classList.add('palo-motion-ready');

    var revealSelectors = [
      '.section',
      '.hero-carousel',
      '.promo-banner',
      '.service-cards',
      '.faq-section',
      '.product-section',
      '.collection-category',
      '.main-search',
      '.palo-editorial'
    ].join(',');

    var reveals = qsa(revealSelectors);
    reveals.forEach(function (el, index) {
      if (el.closest('.site-header, .site-footer')) return;
      el.classList.add('palo-reveal');
      el.style.setProperty('--palo-delay', Math.min((index % 4) * 70, 210) + 'ms');
    });

    qsa('.product-card, .catalog-category__item, .featured-products-section .product-card').forEach(function (card, index) {
      card.classList.add('palo-reveal', 'palo-reveal--card');
      card.style.setProperty('--palo-delay', Math.min((index % 4) * 65, 195) + 'ms');
    });

    qsa('.hero__heading, .hero__description, .hero__buttons, .hero__badge, .palo-editorial__eyebrow, .palo-editorial__content h2, .palo-editorial__text, .palo-editorial__button').forEach(function (el, index) {
      el.classList.add('palo-text-reveal');
      el.style.setProperty('--palo-delay', Math.min((index % 5) * 90, 360) + 'ms');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    qsa('.palo-reveal, .palo-text-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------------
     Init
  --------------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-header]')) {
      initHeader();
      initThemeToggle();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initThemeToggle();
    initHeader();

    var runWhenIdle = window.requestIdleCallback
      ? function (fn) { window.requestIdleCallback(fn, { timeout: 1200 }); }
      : function (fn) { window.setTimeout(fn, 650); };

    runWhenIdle(function () {
      initPaloAnimations();
      initCarousels();
      initHeroCarousel();
      initFaq();
      initProductGallery();
      initProductForm();
      initSizeChart();
      initRecommendations();
      initPredictiveSearch();
      initQuickAdd();
      initContactForm();
      initOrderTracking();
    });
  });
})();
